<div class="bpx-dialog bpx-dialog--wide commit-study-dialog">
  <h2 mat-dialog-title>Commit Study</h2>
  <mat-dialog-content>
    <div>
      Panel: <span id="panel-name">{{ panelName }}</span><br />
      Study Phase: <span id="study-phase">{{ panelPhase }}</span><br />
      Operator: {{operator}}<br /><br />

      {{ studyName }} will be committed on {{ currentDateFormatted }}
    </div>

    <div class="commit-study-dialog__comments">
      <div class="bpx-control">
        <span class="bpx-control__label" id="commit-comments-label">Comments</span>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field bpx-field--textarea">
          <textarea matInput rows="3" aria-labelledby="commit-comments-label" [ngModel]="commentInput" (ngModelChange)="handleCommentInputChange($event)"></textarea>
        </mat-form-field>
      </div>
      @if (commentError) {
      <div class="bpx-error" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ commentError }}</span>
      </div>
      }
    </div>

    <div class="commit-study-dialog__reauth-notice">
      Confirming requires signing in to Active Directory again.
    </div>

    <div class="commit-study-dialog__error-container">
      @if (errorMessage && !isProcessing) {
      <div class="bpx-error" role="alert">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button matRipple class="bpx-btn bpx-btn--primary" (click)="commitStudy()" [disabled]="isProcessing">
      Confirm
    </button>
    <button matRipple class="bpx-btn" [mat-dialog-close] [disabled]="isProcessing">
      Cancel
    </button>
  </mat-dialog-actions>
</div>
